export const KAFKA_EVENTS = {
  COLLECTION_VIEW_EVENT: 'collection.product.view',
  COLLECTION_SCROLL_EVENT: 'collection.product.scrollview',
  PRODUCT_CLICK_EVENT: 'collection.product.pdp.click',
  PRODUCT_QUICK_CLOSET_CLICK: 'collection.product.quickcloset.click',
  PRODUCT_QUICK_CLOSET_DETAILS_CLICK: 'collection.product.quickcloset.details.click',
  PRODUCT_QUICK_CLOSET_EVENT: 'collection.product.quickcloset.closet',
  PRODUCT_CLOSET_EVENT: 'collection.product.pdp.closet'
};

export const MOBILE_THRESHOLD = 0.6;
export const DESKTOP_THRESHOLD = 0.5;
